/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeProfileInfoHistoryDto,
  ApiEnvelopeProfileInfoSnapshotDto,
  ProfileInfoGetHistoryParams
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type profileInfoGetLatestResponse200 = {
  data: ApiEnvelopeProfileInfoSnapshotDto
  status: 200
}

export type profileInfoGetLatestResponse403 = {
  data: ApiEnvelopeProfileInfoSnapshotDto
  status: 403
}

export type profileInfoGetLatestResponse404 = {
  data: ApiEnvelopeProfileInfoSnapshotDto
  status: 404
}

export type profileInfoGetLatestResponseSuccess = (profileInfoGetLatestResponse200) & {
  headers: Headers;
};
export type profileInfoGetLatestResponseError = (profileInfoGetLatestResponse403 | profileInfoGetLatestResponse404) & {
  headers: Headers;
};

export type profileInfoGetLatestResponse = (profileInfoGetLatestResponseSuccess | profileInfoGetLatestResponseError)

export const getProfileInfoGetLatestUrl = (botId: string,) => {




  return `/api/profileinfo/${botId}/latest`
}

export const useProfileInfoGetLatestHook = (): (botId: string, options?: RequestInit) => Promise<profileInfoGetLatestResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getProfileInfoGetLatestUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type profileInfoGetHistoryResponse200 = {
  data: ApiEnvelopeProfileInfoHistoryDto
  status: 200
}

export type profileInfoGetHistoryResponse403 = {
  data: ApiEnvelopeProfileInfoHistoryDto
  status: 403
}

export type profileInfoGetHistoryResponse404 = {
  data: ApiEnvelopeProfileInfoHistoryDto
  status: 404
}

export type profileInfoGetHistoryResponseSuccess = (profileInfoGetHistoryResponse200) & {
  headers: Headers;
};
export type profileInfoGetHistoryResponseError = (profileInfoGetHistoryResponse403 | profileInfoGetHistoryResponse404) & {
  headers: Headers;
};

export type profileInfoGetHistoryResponse = (profileInfoGetHistoryResponseSuccess | profileInfoGetHistoryResponseError)

export const getProfileInfoGetHistoryUrl = (botId: string,
    params?: ProfileInfoGetHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/profileinfo/${botId}/history?${stringifiedParams}` : `/api/profileinfo/${botId}/history`
}

export const useProfileInfoGetHistoryHook = (): (botId: string,
    params?: ProfileInfoGetHistoryParams, options?: RequestInit) => Promise<profileInfoGetHistoryResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: ProfileInfoGetHistoryParams, options?: RequestInit) => {

        return customFetcher(getProfileInfoGetHistoryUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


